import { createContext } from '@change-corgi/core/react/context';

import type { UseLoadGooglePlacesReturn } from '../hooks/useLoadGooglePlaces';

// FIXME should this be a createMandatoryContext?
export const {
	Context: GooglePlacesContext,
	Provider: GooglePlacesContextProvider,
	useContext: useGooglePlacesContext,
} = createContext<
	UseLoadGooglePlacesReturn | undefined,
	{
		status: 'loading' | 'loaded' | 'error';
		autocompleteService?: google.maps.places.AutocompleteService;
		placesService?: google.maps.places.PlacesService;
	}
>(undefined, {
	name: 'GooglePlacesContext',
	processProviderProps: ({ status, autocompleteService, placesService }) => ({
		status,
		autocompleteService,
		placesService,
	}),
});
